<template>
  <custom-modal v-model="showAddNameModal" :confirm-button-loading="isAddAlternativeNameLoading" @confirm="saveOrUpdateAlternativeName" @cancel="$emit('close')">
    <template v-slot:title>{{ formAction }} alternative match name</template>
      <div class="mb-3 mt-4">
        <base-input label="Bookie">
          <select
            class="form-control my-select"
            id="filter"
            v-model="form.bookie"
            name="bookie"
          >
            <option v-for="bookie in bookies" :key="bookie.value" :value="bookie.value">
              {{ bookie.label }}</option
            >
          </select>
        </base-input>
      </div>
      <div class="mb-3 mt-4">
        <base-input label="Category">
          <select
            class="form-control my-select"
            id="filter"
            v-model="form.category"
            name="category"
          >
            <option v-for="category in categories" :key="category" :value="category">
              {{ category }}</option
            >
          </select>
        </base-input>
      </div>
      <div class="mb-3 mt-4 ml-4" v-if="alternativeNames.home_team !== ''">
        <base-input label="Match">
          <div class="form-check">
            <input class="form-check-input" type="radio" v-model="form.match_name" name="inlineRadios" id="inlineRadios1" :value="alternativeNames.home_team" >
            <label class="form-check-label" for="inlineRadios1">{{ alternativeNames.home_team }}</label>
          </div>
          <div class="form-check ">
            <input class="form-check-input" type="radio" v-model="form.match_name" name="inlineRadios" id="inlineRadios2" :value="alternativeNames.away_team">
            <label class="form-check-label" for="inlineRadios2">{{ alternativeNames.away_team }}</label>
          </div>
        </base-input>

      </div>
      <div class="mb-3 mt-4" v-else>
        <base-input label="Match name">
          <input type="text" name="match_name" v-model="form.match_name" class="form-control input_user" value="" placeholder="Match name" required>
        </base-input>
      </div>
      <div class="mb-2">
        <base-input label="Alternative match name">
          <input type="text" name="alternative_name" v-model="form.alternative_name" class="form-control input_pass" value="" placeholder="Alternative name" required>
        </base-input>
      </div>
      <div class="mb-3 mt-4">
        <base-input label="Provider">
          <select
            class="form-control my-select"
            id="filter"
            v-model="form.provider"
            name="provider"
          >
            <option v-for="provider in providers" :key="provider" :value="provider">
              {{ provider }}</option
            >
          </select>
        </base-input>
      </div>

      <base-alert v-show="form.has_error" type="info">
          <span>{{form.error_message}}</span>
      </base-alert>
  </custom-modal>
</template>

<script>
import axios from "axios";
import { BaseAlert } from '@/components';
import CustomModal from "../components/CustomModal.vue";
export default {
  props: {
    showAddNameModal: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {
        return {
          bookie: '',
          match_name: '',
          alternative_name: '',
          category: '',
          provider: '',
          has_error : false,
          error_message : '',
        }
      }
    },
    alternativeNames: {
      type: Object,
      default: () => {
        return {
          home_team: '',
          away_team: '',
        }
      }
    },
    formAction: {
      type: String,
      default: 'Add'
    }
  },
  components: {
    CustomModal,
    BaseAlert,
  },
  data() {
    return {
      isAddAlternativeNameLoading: false,
      bookies: [{ label: 'Odibets', value: 'odibets' }, { label: 'Betika', value: 'betika' }, { label: 'Betlion', value: 'betlion' }, { label: 'Ababet', value: 'ababet' }, { label: 'Wezabet', value: 'Wezabet' }, { label: 'Hakibets', value: 'Hakibets' }, { label: 'Sofascore', value: 'Sofascore' }, { label: 'Sportradar', value: 'sportradar' }],
      categories: ['Football', 'Basketball', 'Rugby', 'Volleyball', 'Handball', 'Baseball', 'American Football', 'Cricket', 'Ice Hockey', 'Futsal', 'FloorBall', 'Bandy', 'Water Polo'],
      providers: ['Flashscore',]
    }
  },
  methods: {

      saveOrUpdateAlternativeName() {
        if (this.formAction == 'Add') {
          this.addAlternativeName()
        } else {
          this.updateAlternativeName()
        }
      },
      addAlternativeName() {
        this.isAddAlternativeNameLoading = true
        axios.post('alternative-game-names', this.form)
        .then(response => {
            this.isAddAlternativeNameLoading = false
            this.$toast.success("Added successfully");
            this.$emit('close')
            this.$emit('added')
        })
        .catch(error => {
            // handle error
            console.log(error);
            this.$toast.error("Error adding");
            this.isAddAlternativeNameLoading = false;
            this.form.error_message = error.response.data.message
            this.form.has_error = true
        });
      },
      updateAlternativeName() {
        this.isAddAlternativeNameLoading = true
        axios.put(`alternative-game-names/${this.form.id}`, this.form)
        .then(response => {
          this.isAddAlternativeNameLoading = false
            this.$toast.success("Updated successfully");
            this.$emit('close')
            this.$emit('added')
        })
        .catch(error => {
            // handle error
            console.log(error);
            this.$toast.error("Error updating");
            this.isAddAlternativeNameLoading = false;
            this.form.error_message = error.response.data.message
            this.form.has_error = true
        });
      },
  },

}
</script>
